import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table';
import {
  AgrLogoWideModule,
  AgrPageDetailModule,
  AgrPageToolbarModule,
  AgrPrintPageModule,
  AgrValueRowModule,
} from '@next/core-lib/components';
import { AgrI18nSharedModule } from '@next/core-lib/i18n';
import { AgrTableModule } from '@next/core-lib/table';
import { LetDirective, PushPipe } from '@ngrx/component';

import { GeneralInfoComponent } from './general-info/general-info.component';
import { SharedModule } from '../shared/shared.module';

@NgModule({
  declarations: [
    GeneralInfoComponent,
  ],
  imports: [
    SharedModule,
    LetDirective, PushPipe,
    MatIconModule,
    MatExpansionModule,
    MatDividerModule,
    MatTableModule,
    AgrPageToolbarModule,
    AgrValueRowModule,
    AgrLogoWideModule,
    AgrPrintPageModule,
    AgrPageDetailModule,
    AgrTableModule,
    CommonModule,
    AgrI18nSharedModule,
  ],
  exports: [GeneralInfoComponent],
})
export class ReportsModule {}
